mutation ApprovalSetupApprovalRevoke(
  $input: ApprovalSetupApprovalRevokeInput!
) {
  approvalSetupApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
